<db-dialog-wrapper [dialog]="this" [width]="'500px'">
  <div class="db-coupon-apply-response-dialog">
    <div class="db-coupon-apply-response-dialog__header">{{headerText}}</div>
    <div class="db-coupon-apply-response-dialog__message">{{messageText}}</div>
    <div class="db-coupon-apply-response-dialog__buttons">
      <a class="db-button db-button_info" (click)="close_popup()"><span>{{buttonText}}</span></a>
    </div>
  </div>
</db-dialog-wrapper>
